export function getEnv(
  key: string,
  processEnvValue: string | undefined,
  fallback?: string,
): string | undefined {
  const runtimeEnvs =
    typeof window !== 'undefined' && (window as any).RUNTIME_ENV ? (window as any).RUNTIME_ENV : {};

  if (runtimeEnvs[key]) {
    return runtimeEnvs[key];
  }

  return processEnvValue || fallback;
}
